import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import TipoAcaoService from '../../app/service/TipoAcaoService'

class TipoAcao extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      codigo: '',
      tipo: null,
      tipos: [],
      nome: '',
      detail: '',
      modalTipo: null,
      modalTipoAlterar: null,
      openSpinner: false
    }

    this.tipoAcaoService = new TipoAcaoService();

    this.renderFooterCadastroTipo = this.renderFooterCadastroTipo.bind(this);
    this.renderFooterAlterarTipo = this.renderFooterAlterarTipo.bind(this);
    this.acoes = this.acoes.bind(this);
    this.accept = this.accept.bind(this);
  }

  renderFooterCadastroTipo(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarTipo}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterAlterarTipo(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarTipo}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  alterarTipo = async () => {
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Tipo de Ação', detail:'Informe o Tipo de Ação', life: 4000});
      return;
    }
    const usuarioLogado = this.context.usuarioAutenticado;
    const tipo = {
      codigo: this.state.codigo,
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }
    this.setState({openSpinner: true});
    await this.tipoAcaoService.alterarTipo(tipo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipo de Ação', detail:'Tipo de Ação alterado com sucesso !', life: 4000});
        this.listarTiposAcao();
        this.fecharModal('modalTipoAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipo de Ação', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  cadastrarTipo = async () => {
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Tipo de Ação', detail:'Informe o Tipo de Ação', life: 4000});
      return;
    }
    const usuarioLogado = this.context.usuarioAutenticado;
    const tipo = {
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }
    this.setState({openSpinner: true});
    await this.tipoAcaoService.cadastrarTipo(tipo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipo de Ação', detail:'Tipo de Ação cdastrado com sucesso !', life: 4000});
        this.listarTiposAcao();
        this.fecharModal('modalTipo');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipo de Ação', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  listarTiposAcao = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tipoAcaoService.listarTipoAcao(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tipos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipo de Ação', detail:`${this.state.detail}`, life: 4000});
      })
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  limparCampos = () => {
    this.setState({nome: ''});
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarTipo(rowData)}
                tooltip="Editar Tipo de Ação" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Tipo de Ação" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  async consultarTipo(tipo) {
    this.setState({openSpinner: true});
    await this.tipoAcaoService.consultarTipo(tipo.codigo)
      .then(response => {
        this.setState({tipo: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({nome: response.data.nome});
        this.abrirModaAlterar('modalTipoAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipo de Ação', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  confirmaExclusao(area) {
    this.setState({codigo: area.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir a Tipo de Ação?',
        header: 'Exclusão de Tipo de Ação',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  async excluirTipo() {
    this.setState({openSpinner: true});
    await this.tipoAcaoService.excluirTipo(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipo de Ação', detail:'Tipo de Ação excluído com sucesso', life: 4000});
        this.listarTiposAcao();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipo de Ação', detail:`${this.state.detail}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  accept() {
    this.excluirTipo();
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarTiposAcao();
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          {/**Cadastro de Tipos de Ação */}
          <Dialog header="Cadastro de Tipos de Ação"
                    visible={this.state.modalTipo} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroTipo('modalTipo')} 
                    onHide={() => this.fecharModal('modalTipo')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeTipo">Nome</label>
                        <InputText id="nomeTipo" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Tipo de Ação */}
          <Dialog header="Alterar Tipo de Ação"
                    visible={this.state.modalTipoAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarTipo('modalTipoAlterar')} 
                    onHide={() => this.fecharModal('modalTipoAlterar')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeTipoAlterar">Nome</label>
                        <InputText id="nomeTipoAlterar" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-share-alt"></i>
                        <span> Tipos de Ação</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalTipo')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.tipos}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      emptyMessage=" "
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                      <Column field="nome" header="Nome"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}
TipoAcao.contextType = AuthContext;
export default withRouter (TipoAcao)